import {LIVE_INIT, LIVE_UPDATE, TIMETABLE_INIT, TIMETABLE_UPDATE} from 'sagas/actions';

import * as LiveActions from 'actions/Live';
import * as TimeTableActions from 'actions/Timetable';
import * as ChangeLanguageActions from 'actions/changeLanguage';

export default function versionReducer(version, action) {
    switch (action.type) {
        case LiveActions.CLEAR_LIVE:
        case TimeTableActions.CLEAR_TIME_TABLE:
        case LIVE_INIT.FAILURE:
        case LIVE_UPDATE.FAILURE:
        case TIMETABLE_INIT.FAILURE:
        case TIMETABLE_UPDATE.FAILURE:
        case ChangeLanguageActions.CHANGE_LANGUAGE:
            return 0;

        case LIVE_INIT.SUCCESS:
        case LIVE_UPDATE.SUCCESS:
        case TIMETABLE_INIT.SUCCESS:
        case TIMETABLE_UPDATE.SUCCESS:
            return action.data.version
    }

    return version;
}



// WEBPACK FOOTER //
// ./js/shared/reducers/entities/versionReducer.js